import React from 'react'
import LazeCuttingPage from './LazeCuttingPage'
import '../styles/index.scss'


function LazeCuttingPageContainer() {
    return (
        <div className="LazeCuttingPageContainer">
            <LazeCuttingPage />
        </div>
    )
}

export default LazeCuttingPageContainer